// src/components/Tour/ProductTour.js
import React from 'react';
import { useTour } from '../../contexts/TourContext';
import TourStep from './TourStep';

const ProductTour = () => {
  const { tourState, nextStep, prevStep, endTour, skipTour } = useTour();

  if (!tourState.isActive || !tourState.steps.length) {
    return null;
  }

  const currentStepData = tourState.steps[tourState.currentStep];

  return (
    <TourStep
      step={currentStepData}
      currentStep={tourState.currentStep}
      totalSteps={tourState.steps.length}
      onNext={nextStep}
      onPrev={prevStep}
      onSkip={skipTour}
      onFinish={endTour}
    />
  );
};

export default ProductTour;